/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicineDetailAliases {
  CONTEXTUAL_BAR_MEDICINE_DETAIL = 'contextual-bar-medicine-detail',
  DATE_FIELD_MEDICINES_FORMULARY_START_DATE_MY_CHART_MEDICINE_DETAIL = 'date-field-medicines-formulary-start-date-my-chart-medicine-detail',
  FIELD_ADMINISTRATE_ROUTE = 'field-administrate-route',
  FIELD_DOSE = 'field-dose',
  FIELD_INTERVAL = 'field-interval',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_MEDICINES = 'form-medicines',
  INPUT_FORMULARY_MEDICINE_MEDICINE_MY_CHART_MEDICINE_DETAIL = 'input-formulary-medicine-medicine-my-chart-medicine-detail',
  INPUT_MEDICINES_FORMULARY_ADMINISTRATIVE_ROUTE_MY_CHART_MEDICINE_DETAIL = 'input-medicines-formulary-administrative-route-my-chart-medicine-detail',
  INPUT_MEDICINES_FORMULARY_DOSE_MY_CHART_MEDICINE_DETAIL = 'input-medicines-formulary-dose-my-chart-medicine-detail',
  INPUT_MEDICINES_FORMULARY_INTERVAL_MY_CHART_MEDICINE_DETAIL = 'input-medicines-formulary-interval-my-chart-medicine-detail',
  INPUT_MEDICINES_FORMULARY_UNIT_MEASUREMENT_MY_CHART_MEDICINE_DETAIL = 'input-medicines-formulary-unit-measurement-my-chart-medicine-detail',
  LAYOUT_MEDICINE_DETAIL = 'layout-medicine-detail',
  PANEL_MEDICINES = 'panel-medicines',
}
export { MyChartMedicineDetailAliases };
